export default {
  Title: 'Upload Your Resume',
  Subtitle: 'Upload a PDF, DOCX, or TXT file to help speed up your application.',
  EasyUpload: 'Easy Upload',
  EasyUploadDesc: 'Drag and drop your resume or browse to select a file.',

  SecureProcess: 'Secure Processing',
  SecureProcessDesc: 'Your data is handled with care and used only to support your application.',

  DropZoneTitle: 'Choose a file or drag & drop it here',
  DropZoneDesc: 'Accepted formats: PDF, DOCX, TXT (max 10MB).',

  Error: 'There was a problem processing your resume',

  UploadedFiles: 'Uploaded Files',
  Remove: 'Remove',
  ProcessResume: 'Process Resume',

  Processing: {
    Title: 'Processing your resume',
    Subtitle: 'This helps us fill in your application faster.',
    Status: 'We\'re reading your resume',
    TimeEstimate: 'Almost there... This usually takes about 30 seconds.',
  },

  Success: {
    Title: 'Resume Processed Successfully!',
    Message: 'Your resume has been analyzed and your information has been saved.',
    NextStep: 'Click "Next" to continue with your application.',
  },

  AlreadySubmitted: {
    Title: 'Resume Already Submitted',
    Message: 'Your resume has already been processed. You can proceed to the next step to continue your application.',
  },

  PrivacyNote: 'We only use your resume to support your application and do not share it externally.',
};
